import { Route, Routes } from "react-router-dom";
import OrganizationsList from "./OrganizationsList";
import OrganizationDetail from "./OrganizationDetail";

/**
 * Organizations domain page for the Platform portal — owns the list + detail nested routes,
 * following the app-wide "outer registry -> domain page -> nested routes" convention.
 */
const PlatformOrganizations = () => {
  return (
    <Routes>
      <Route index element={<OrganizationsList />} />
      <Route path=":orgId" element={<OrganizationDetail />} />
    </Routes>
  );
};

export default PlatformOrganizations;
